import * as React from 'react'

function SvgMa(props) {
	return (
		<svg viewBox="0 0 900 600" width="1em" height="1em" {...props}>
			<path fill="#c1272d" d="M900 0H0v600h900z" />
			<path
				d="M450 224.315l-44.467 136.87 116.401-84.559h-143.87l116.403 84.559z"
				fill="none"
				stroke="#006233"
				strokeWidth={14.63}
			/>
		</svg>
	)
}

export default SvgMa
